import React, { FC } from 'react';
import { WarningFilled } from '@ant-design/icons';
import { Button, Col, Modal, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { i18nKey } from 'src/locales/i18n';
import styles from './quit-confirm-popup.module.less';
export interface IQuitConfirmationPopupProps {
	open: boolean;
	onClose: () => void;
	onQuit: () => void;
}
const QuitConfirmPopup: FC<IQuitConfirmationPopupProps> = ({ open, onClose, onQuit }) => {
	const [t] = useTranslation();
	return (
		<>
			<Modal open={open} title={null} footer={null} closable={false} className={styles.modalBox}>
				<Row className={styles.marginBottom}>
					<Col span={24}>
						<Typography.Title level={4} className={styles.title}>
							<WarningFilled
								style={{
									color: '#F5222D'
								}}
							/>
							{t(i18nKey.onboarding.cancel.title)}
						</Typography.Title>
					</Col>
				</Row>
				<Row gutter={[16, 16]} className={styles.description}>
					<Col span={24}>
						<Typography.Text>{t(i18nKey.onboarding.cancel.description)}</Typography.Text>
					</Col>
					<Col span={24}>
						<Typography.Text>{t(i18nKey.onboarding.cancel.description1)}</Typography.Text>
					</Col>
				</Row>
				<Row gutter={[16, 16]} className={styles.marginBottom}>
					<Col span={12}>
						<Button
							onClick={() => {
								onClose();
							}}
							type="primary"
							block
							size="middle"
							className="greyBtn">
							{t(i18nKey.onboarding.cancel.stayBtn)}
						</Button>
					</Col>
					<Col span={12}>
						<Button
							onClick={() => {
								onQuit();
							}}
							type="primary"
							block
							size="middle">
							{t(i18nKey.onboarding.cancel.leave)}
						</Button>
					</Col>
				</Row>
			</Modal>
		</>
	);
};

export default QuitConfirmPopup;
